import React from 'react';
import { formatCurrency } from 'js/services/Format';

const StoreProducts = ({ items }) => {
  return (
    <div className="store-products">
      <div className="products-container">
        <h2
          className="store-title"
        >Store</h2>
        <div className="scroller">
          <div className="grid">
            {items.map((product) => {
              return <div className="product-item" key={`product-${product.alias}`}>
                <div className='product-image'>
                  <img src={product.image} alt={product.title} />
                </div>
                <div className="product-meta">
                  <h4>{product.title}</h4>
                  <p>{product.description}</p>
                </div>
                <div className="price d-flex justify-content-between align-items-center">
                  <span>{formatCurrency(product.price)}</span>
                  <img src="/images/v2/mseller/kebab-menu.svg" />
                </div>
              </div>
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default StoreProducts;
